import { Container, Flex, Icon, Text } from "@chakra-ui/react";
import { Button, GoToMainButton } from "components";
import { Heading } from "elements";
import { CheckIcon } from "@chakra-ui/icons";
import { BsCreditCard } from "react-icons/bs";

const PaymentSuccessful = () => {
  return (
    <Container maxW='container.md' marginLeft={0}>
        <GoToMainButton />
        <Flex marginTop={5} flexDirection='column' marginLeft={0} marginBottom={5} paddingLeft={0}>
            <Flex align='center' position='relative'>
                <Icon as={BsCreditCard} w={20} h={20} marginRight={8} />
                <Flex position='absolute' top={1} left={14} padding={3} backgroundColor='#90D933'  borderRadius='50px'>
                    <CheckIcon color="white"/>
                </Flex>
                <Flex flexDirection='column'>
                    <Heading title="Your payment is successful!" color="#90D933" fontSize="42px" fontWeight={700}/>
                    <Text color="#6F6F6F" fontWeight={400} fontSize="12px">We have received your payment for Booking 1045830575. Details of transaction are included below</Text>
                </Flex>
            </Flex>
            <Flex flexDirection='row' justifyContent='space-between'marginTop={20} marginBottom={20}>
                <Flex flexDirection='column' marginRight='50px'>
                    <Text color="#6F6F6F" fontWeight={500} fontSize="16px">You paid</Text>
                    <Text color="#1F1E1E" fontSize="20px" fontWeight={500}>€ 1.595</Text>
                </Flex>
                <Flex flexDirection='column' marginRight='50px'>
                    <Text color="#6F6F6F" fontWeight={500} fontSize="16px">Payment ID </Text>
                    <Text color="#1F1E1E" fontSize="20px" fontWeight={500}>1045830575</Text>
                </Flex>
                <Flex flexDirection='column' marginRight='50px'>
                    <Text color="#6F6F6F" fontWeight={500} fontSize="16px">Payment Type</Text>
                    <Text color="#1F1E1E" fontSize="20px" fontWeight={500}>Debit card</Text>
                </Flex>
                <Flex flexDirection='column' marginRight='50px'>
                    <Text color="#6F6F6F" fontWeight={500} fontSize="16px">Transaction Time</Text>
                    <Text color="#1F1E1E" fontSize="20px" fontWeight={500}>12/08/2022 11:50:43</Text>
                </Flex>
            </Flex>
            <Flex align='center' marginBottom={20}>
                <Text color="#6F6F6F" fontSize="20px" fontWeight={500}>We’ve sent a confirmation email to</Text>
                <Text marginLeft={2} fontWeight={700}>{'  '}blablabla@gmail.com</Text>
            </Flex>
                <Button size="lg"label="Check My Offers" onClick={function (): void {
                    throw new Error("Function not implemented.");
                } } colorScheme="blue" />
        </Flex>
        
    </Container>
  );
};

export { PaymentSuccessful };
